import React, { useState,useEffect } from "react";
import Launch from "../Launch";
import Login from "../Login";
import Loader from "../../components/Loader/Loader";
import Otp from "../../Otp";
import axios from "axios";
import AccountGrid from "../../components/AccountGrid";
import tambola_logo_login from '../../images/brs_logo_1.png';
//import kidlogin from '../../images/kidlogin.png';
let accountId=0;
let countdownInterval;
const API_PATH="https://brsinbox.com/API/"
//let timeLeft = 30; // Initial time in seconds
function generateOTP(length = 6) { 
  const digits = '0123456789';
  let otp = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * digits.length);
    otp += digits[randomIndex];
  }
  return otp;
}
 function enableResendBtn() {
		document.getElementById('timer-display').textContent = "";
		document.getElementById('resend-button').style.display = 'block';
		document.getElementById('timer-display').style.display = 'none';
}
	
export const Verify = (props) => {
	
//console.log(props);
	const otpVal=props.otp;
	const userName=props.userName;
	const userTitle=props.userTitle;

	const [otpStr, setOtpStr] = useState(otpVal);
	const [isLogin, setIsLogin] = useState(false);
	const [isbackToLogin, setIsBackToLogin] = useState(false);
	const [isLoader, setIsLoader] = useState(false);
	const [isMACs, setIsMACs] = useState(false);
	const [accounts, setAccounts] = useState(false);
	const [isLaunch, setIsLaunch] = useState("");
	const [mno, setMno] = useState(0);
	const [userId, setUserId] = useState(0);
	const [ownerId, setOwnerId] = useState(0);
	const [resendOtpLimit, setRendOtpLimit] = useState(2);
	const [errors, setErrors] = useState({
	apiError: "",
	});
  
  const stopTimer = async (timeLeft) => {
		clearInterval(countdownInterval);
		countdownInterval = null; // Reset the interval ID
		document.getElementById('resend-button').style.display = 'none';
  };
   const startOtpTimer = async (timeLeft) => {
	   
		   if (!countdownInterval) {
			   
			   document.getElementById('timer-display').style.display = 'block';
			   document.getElementById('timer-display').textContent = `OTP expiry in 00:${String(timeLeft).padStart(2, '0')}`;
			   document.getElementById('resend-button').style.display = 'none';
			   
				countdownInterval = setInterval(() => {
					timeLeft--;
					if (timeLeft <= 0) {
						clearInterval(countdownInterval);
						document.getElementById('timer-display').textContent = "";
						var resendOtpLimitIdVal=document.getElementById('resendOtpLimitId').value;
						if(resendOtpLimitIdVal>0){
						 document.getElementById('resend-button').style.display = 'block';
						}else{
							 setIsBackToLogin(true);
						}
						timeLeft = 0; // Reset for next use
					}else if(timeLeft >= 61){
						clearInterval(countdownInterval);
						document.getElementById('timer-display').textContent = "";
						document.getElementById('resend-button').style.display = 'none';
					}else {
						document.getElementById('timer-display').textContent = `OTP expiry in 00:${String(timeLeft).padStart(2, '0')}`;
					}
				}, 1000);
			
		   }else{
			  // console.log('ER');
		   }
		   
   };
	   
   const resendOtp22 = async () => {
	   
		var fourDigitOtp = generateOTP(4); 
		
		//fourDigitOtp = 1234; 
		setErrors({ apiError: ""});
		setOtpStr(fourDigitOtp);
		
		 const payload = {
		  api4m:"1",
		  logicType:"2",
		  userName: userName,
		  userTitle: userTitle,
		  _tps_val: fourDigitOtp,
		};
		setIsLoader(true);
		
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; 
		axios
		  .post(API_PATH+"senttps.php",payload)
		  .then((response) => {
			console.log("Response Data:", response.data);
			if (response?.data?.Status === "1" || response?.data?.Status === 1) {
				setIsLoader(false);
				setErrors({ apiError: "Resend otp successfully..."});
				stopTimer();
				startOtpTimer(60); 
				setRendOtpLimit(0);
			}else{
				 setIsLoader(false);
				 setErrors({ apiError: "Network issue, please try again!!"});
				 enableResendBtn(); 
			}
		  })
		  .catch((error) => {
			  setIsLoader(false);
			  setErrors({ apiError: error });
		  });
		 return false;
   };
   
  const handleSubmit = async () => {
	 
	const sessionAccountId=localStorage.getItem("_tm_laccId");
	if(sessionAccountId>0 && sessionAccountId !== "-" && typeof sessionAccountId !== "undefined"){
		const payload2 = {
		api4m:"1",
		logicType:"2",
		userName: userName,
		userTitle: userTitle,
		accountId: sessionAccountId,
		};
        handleAccountSwitch(payload2);   
	}else{
	const payload = {
      api4m:"1",
      logicType:"2",
      userName: userName,
      userTitle: userTitle,
      accountId: accountId,
    };
		
	setIsLoader(true);
	axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios
      .post(API_PATH+"getAccounts.php",payload)
      .then((response) => {
        console.log("Response Data:", response.data);
		if (response?.data?.Status === "1" || response?.data?.Status === 1) {
			
			setIsLoader(false);
			if(response?.data?.aCount >= 2){
				setIsMACs(true);
				localStorage.setItem('isMACs',true);
				setAccounts(response.data.accounts);
				localStorage.setItem('_tm_userData',"Multiple Accounts");
				localStorage.setItem('_tm_isMACs',"Y");
			}else if(response?.data?.aCount === 1){
				setIsMACs(false);
				localStorage.setItem('isMACs',false);
				const payload1 = {
				api4m:"1",
				logicType:"2",
				userName: userName,
				userTitle: userTitle,
				accountId: response.data.aId,
				};
				handleAccountSwitch(payload1);
			}else{
				localStorage.setItem('isMACs',false);
				setIsMACs(false);
				handleAccountSwitch(payload);
			}
		}else{
			 setIsLoader(false);
			 setErrors({ apiError: "Network Issue ,please try again!"});
			 stopTimer();
			 if(resendOtpLimit>0){
			    enableResendBtn(); 
			 }else{
				  setIsBackToLogin(true);
			 }
		}
      })
      .catch((error) => {
		  setIsLoader(false);
		  setErrors({ apiError: error });
		  stopTimer();
      }); 
	}
	  
	 return false;
   };
   
   const handleAccountSwitch = (payload) => {
	setIsLoader(true);   
	axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    axios
      .post(API_PATH+"verchk.php",payload)
      .then((response) => {
        console.log("Response Data:", response.data);
		if (response?.data?.Mssg === "You have successfully logged in" || response?.data?.Status === "1" || response?.data?.Status === 1) {
			localStorage.setItem("_tm_isLaunch", "Y");
			localStorage.setItem('_tm_isMACs',"N");
			setIsLogin(true);
			setIsLoader(false);
			var uData=response.data.Content;
			var userName=uData[0].mobileNumber;
			var ownerId=uData[0].ownerId;
			var uId=uData[0].userId;
			callAppTrack(ownerId,userName,uId,3);
			//var mobileNumber=uData[0].mobileNumber;
			setUserId(uId);
			setOwnerId(ownerId);
			setMno(userName);
			setIsLaunch('Y');
			localStorage.setItem("_tm_luId", uId);
			localStorage.setItem("_tm_laccId", ownerId);
			localStorage.setItem("_tm_lmno", userName);
			localStorage.setItem("_tm_userData", JSON.stringify(uData));
			localStorage.setItem("_tm_userData", JSON.stringify(uData));
			
			localStorage.setItem("_tm_luId", uId);
			localStorage.setItem("_tm_laccId", ownerId);
			localStorage.setItem("_tm_lmno", userName);
		}else{
			 setIsLoader(false);
			 setErrors({ apiError: "Network Issue ,please try again!"});
			 stopTimer();
			 if(resendOtpLimit>0){
			    enableResendBtn(); 
			 }else{
				  setIsBackToLogin(true);
			 }
		}
      })
      .catch((error) => {
		  setIsLoader(false);
		  setErrors({ apiError: error });
		  stopTimer();
      }); 
	   
   }
  const callAppTrack = async (ac,pn,info,t_type) => {
		const payload4 = {
		  mno: pn,
		  ownerId: ac,
		  info: info,
		  t_type: t_type,
		};
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
		axios
		  .post(API_PATH+"api/app_track.php",payload4)
		  .then((response) => {
			//console.log("Response Data:", response.data);
		  })
		  .catch((error) => {
			setErrors({ apiError: error });
		  });
	}
   const handleOtpSubmit = (otp: number) => {
	     
	      if(parseInt(otp) === parseInt(otpStr)){
			  setErrors({ apiError: "* Verification successfully!!"});
			  stopTimer();
			  const _tm_laccId=localStorage.getItem("_tm_laccId");
			  const _tm_lmno2=localStorage.getItem("_tm_lmno");
			  callAppTrack(_tm_laccId,_tm_lmno2,otp,2);
			  handleSubmit();
		  }else{
			  setErrors({ apiError: "Invalid OTP"});
			  //stopTimer();
		  }
	}; 
	
  useEffect(() => {
	  
			const _tm_isMACs222=localStorage.getItem("_tm_isMACs");
			if(_tm_isMACs222 === "Y"){ setIsMACs(true); }
			
			if(!_tm_isMACs222){ startOtpTimer(60);  }
			
		}, []);	
		
  return (
   <section>  {isLoader?<Loader/>:<span></span>}


		<div>
		{(() => {
		if (isLogin) {
		  return (
			<div><Launch userId={userId} ownerId={ownerId} mno={mno} isLaunchVal={isLaunch}/></div>
		  )
		} else if (isbackToLogin) {
		  return (
			<div><Login/></div>
		  )
		}else if(isMACs){
          return (
		  
		     <div>
				<AccountGrid
				title="Choose your account"
				accounts={accounts}
				onSelect={(account) => { 
				handleAccountSwitch(account);
				}}
				/>
			 </div>
		  )
		}else {
		  return (
				<div>
				
				<div className="logo-section">
				<img src={tambola_logo_login} alt={tambola_logo_login} className="logo" />
				<div className="brand-name">
				BRS
				</div>
				<div className="brand-tagline">
				Bharat Rashtra Samithi
				</div>
				</div>
				
				<div className="login-wrapper"><div id="login-form" className="login-card"><h2>Please enter the otp here</h2>{errors?.["apiError"] && (<div className="error-message">{errors?.["apiError"]}</div>)}
				
				<Otp length={4} onSubmit={handleOtpSubmit}/> <input type="hidden" id="resendOtpLimitId" value={resendOtpLimit} />
				
				<div className="mb-1">
				
				<label>
				<span id="timer-display"></span> 
				<span id="resend-button" onClick={() => resendOtp22()} style={{ fontSize: 14, color: "#24CF57",display:"none" }}>Re-send otp!</span>
				</label>
				
				</div>
				
				</div></div>
				<footer>
				© 2025 www.spearup.io. All rights reserved.
				</footer>
				
				<span id="PING_IFRAME_FORM_DETECTION" style={{display: "none"}}></span>
				
				</div>
		  )
		}
		})()}
		
		</div> 
		
		</section> 
  ); 
};

export default Verify;
